var first = 0;
var cheight = 0
var auxm = 0;
var last = "";
var lchange = 0;
var first = 1;










var sort_hiatus = function(){
    var options = $("#hiatus_weeks option");            // Collect options
    options.detach().sort(function(a,b) {               // Detach from select, then Sort
        var at = $(a).text();
        var bt = $(b).text();
        return (at > bt)?1:((at < bt)?-1:0);            // Tell the sort function how to order
    });
    options.appendTo("#hiatus_weeks");
};

var calc_diff_days = function(){
    //var interv = $("#date_range").val();
    //interv = interv.split(" - ");
    var start = moment($("#date_range_1").val(), "MM/DD/YYYY");
    var end = moment($("#date_range_2").val(), "MM/DD/YYYY");
    return end.diff(start, 'days') + 1;

    // var total_days = 0;
    // $("#flight_weeks_inputs input").each(function (index,value) {
    //         total_days += 7 - (moment($(value).val()).weekday() - 1)
    // })
    // return total_days - (moment(interv[0]).weekday() - 1)
};

var calc_diff_weeks = function(){
    // var interv = $("#date_range").val();
    // interv = interv.split(" - ");
    var interv = [$('#date_range_1').val(), $('#date_range_2').val()]
    var start = moment(interv[0], "MM/DD/YYYY");
    var end = moment(interv[1], "MM/DD/YYYY");
    return Math.ceil(end.endOf('isoWeek').diff(start.startOf('isoWeek'), 'days')/7);

    // var total_days = 0;
    // $("#flight_weeks_inputs input").each(function (index,value) {
    //         total_days += 7 - (moment($(value).val()).weekday() - 1)
    // })
    // return total_days - (moment(interv[0]).weekday() - 1)
};

if($('#app-flight-dates').length){

    $("#scroll_up").on('click', function(){
        cheight = (cheight + 200 >= auxm) ? cheight : cheight + 200;
        $('#flight_weeks_container').scrollTop( cheight );
    });

    $("#scroll_down").on('click', function(){
        cheight = (cheight - 200 < 0) ? 0 : cheight - 200;
        $('#flight_weeks_container').scrollTop( cheight );
    });

    $(document).ready(function () {
        var df, dt, arr_df, arr_dt = '';
        if ($("#update_date_from").val() != ""){
            arr_df = $("#update_date_from").val().split(' ')[0].split('-');
            df = arr_df[1] + '/' + arr_df[2] + '/' + arr_df[0];
            arr_dt = $("#update_date_to").val().split(' ')[0].split('-');
            dt = arr_dt[1] + '/' + arr_dt[2] + '/' + arr_dt[0];
        }

        $("#daterange-input-container-1 input").inputmask('mm/dd/yyyy', {
            "oncomplete": function () {
                //$(this).attr('data-completed', 'true');
            },
            "onincomplete": function () {
                //$(this).attr('data-completed', 'false');
            },
            showMaskOnHover: false
        }).on("focus", function () {
            date_flag_value = $(this).val()
            let date_input = this
            setTimeout(function () {
                $(date_input).select()
            }, 10)
        });

        var date_flag_value = ""

        $("#daterange-input-container-2 input").inputmask('mm/dd/yyyy', {
            "oncomplete": function () {
                //$(this).attr('data-completed', 'true');
            },
            "onincomplete": function () {
                //$(this).attr('data-completed', 'false');
            },
            showMaskOnHover: false
        }).on("focus", function () {
            date_flag_value = $(this).val()
            let date_input = this
            setTimeout(function () {
                $(date_input).select()
            }, 10)
        });
        $('#daterange-input-container-1 input').daterangepicker({
            "showWeekNumbers": true,
            "singleDatePicker": true,
            "startDate": (df == undefined) ? moment().day(8) : df,
            //"endDate": (dt == undefined) ? moment().day(8).add(5, 'weeks').add(-1, 'days') : dt,
            "autoApply": true,
            "dateLimit": {
                "weeks": 105
            },
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        });
        $('#daterange-input-container-2 input').daterangepicker({
            "showWeekNumbers": true,
            "singleDatePicker": true,
            //"startDate": (df == undefined) ? moment().day(8) : df,
            "startDate": (dt == undefined) ? moment().day(8).add(5, 'weeks').add(-1, 'days') : dt,
            //"minDate" : $("#date_range_1").val(),
            "autoApply": true,
            "dateLimit": {
                "weeks": 105
            },
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1,
                // beforeShow: function(elem, ui) {
                //     $(ui.dpDiv).on('click', 'tbody .ui-datepicker-week-col', function() {
                //      //   $(elem).val('Week ' + $(this).text()).datepicker( "hide" );
                //         $(elem).val('Week ' + 15).datepicker( "hide" );
                //     });
                // }
            }
        });

        $("#response_time_container input").daterangepicker({
            "showWeekNumbers": false,
            "singleDatePicker": true,
            "timePicker": true,
            "autoUpdateInput": false,
            "locale": {
                "cancelLabel": 'Clear'
            }
        });
        $('#response_time_container input').on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('MM/DD/YYYY hh:mm:ss A'));
        });
        $("#response_time_container input").on("focus", function () {
            let date_input = this
            setTimeout(function () {
                $(date_input).select()
            }, 10)
        });


        //if($('#has_orders').val() !== '1') {
            if (df !== '' && typeof df !== 'undefined' && typeof df !== undefined && df !== null) {
                //$("#flight_dates_date_range").hide();
                showCalendar(false,false,$('input[name="calendar_type"]:checked').val());
                console.log("false1");
            } else {
                $('#flight_weeks_container').html('<div class="help-text text-center">Please input a Date Range to set this Campaign\'s Flight Weeks.</div>');
                //$('#flight_weeks_inputs').html('');
                showCalendar(true,false,$('input[name="calendar_type"]:checked').val());
                console.log("true1");
            }
        //}

        $("#date_range_1").on('change', function(){
            console.log("#date_range_1",$(this).val(), $("#date_range_2").val(), date_flag_value)
            if(date_flag_value !== $(this).val() && lchange == 0)
                if(moment($(this).val(), "MM/DD/YYYY") > moment($("#date_range_2").val(), "MM/DD/YYYY")) {
                    $('#date_range_2').data('daterangepicker').setStartDate(moment($(this).val(), "MM/DD/YYYY").add(5, 'weeks').add(-1, 'days').format("MM/DD/YYYY"))
                    $("#date_range_2").val(moment($(this).val(), "MM/DD/YYYY").add(5, 'weeks').add(-1, 'days').format("MM/DD/YYYY")).trigger("change")
                }
            else if(calc_diff_weeks() > 105){
                    $('#date_range_2').data('daterangepicker').setStartDate(moment($(this).val(), "MM/DD/YYYY").add(1, 'year').add(-1, 'days').format("MM/DD/YYYY"));
                    $("#date_range_2").val(moment($(this).val(), "MM/DD/YYYY").add(1, 'year').add(-1, 'days').format("MM/DD/YYYY")).trigger("change");
                }
            else {
                    if ($('#has_orders').val() !== '1') {
                        console.log("true2");
                        $("#flight_weeks_inputs").html('');
                        showCalendar(true, true, $('input[name="calendar_type"]:checked').val());
                    } else {
                        console.log("false1");
                    }
                }
            pulll_stations_from_titan();
        });
        $("#date_range_2").on('change', function(){
            console.log("#date_range_2",$("#date_range_1").val(), $(this).val(), date_flag_value)
            if(date_flag_value !== $(this).val() && lchange == 0)
                if(moment($("#date_range_1").val(), "MM/DD/YYYY") > moment($(this).val(), "MM/DD/YYYY")) {
                    $('#date_range_1').data('daterangepicker').setStartDate(moment($(this).val(), "MM/DD/YYYY").subtract(5, 'weeks').add(1, 'days').format("MM/DD/YYYY"))
                    $("#date_range_1").val(moment($(this).val(), "MM/DD/YYYY").subtract(5, 'weeks').add(1, 'days').format("MM/DD/YYYY")).trigger("change")
                }
            else if(calc_diff_weeks() > 105) {
                    $('#date_range_1').data('daterangepicker').setStartDate(moment($(this).val(), "MM/DD/YYYY").subtract(1, 'year').add(1, 'days').format("MM/DD/YYYY"))
                    $("#date_range_1").val(moment($(this).val(), "MM/DD/YYYY").subtract(1, 'year').add(1, 'days').format("MM/DD/YYYY")).trigger("change")
            }
            else {
                    if ($('#has_orders').val() !== '1') {
                        console.log("true2");
                        $("#flight_weeks_inputs").html('');
                        showCalendar(true, true, $('input[name="calendar_type"]:checked').val());
                    } else {
                        console.log("false2");
                    }
                }
            pulll_stations_from_titan();
        });

        $('#edit_flight_dates_btn').on('click', function(){
            if($('#weeks_count').val() <= 105) {
                $('#revisions_affected').val([]);
                if($('#has_orders_two').val() == 1) {
                    show_loader();
                    var inputs_container = $('#flight_weeks_inputs');
                    var params = {
                       start : $('#date_range_1').val(),
                       end : $('#date_range_2').val(),
                        campaign_weeks : inputs_container.find('input[name="campaign_weeks[]"]').serializeArray(),
                        camp_id : campaign_obj.id,
                    };

                    $.ajax({
                        type: 'POST',
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                        url: '/campaign/fd/update/get/orders_invoices',
                        data: JSON.stringify(params),
                        contentType: "application/json",
                        dataType: 'json',
                        encode: true,
                        success: function (response) {
                            hide_loader();
                            console.log('response ', response);
                            if(response.delete === false){
                                swal({
                                        title: "Warning",
                                        text: response.text,
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        //cancelButtonText: 'No',
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {
                                        if (isConfirm) {
                                        }
                                    });
                            }
                            else if(response.delete === true && response.archive === true) {
                                $('#fdOrderedToChange').modal('show');
                                $('#revisions_affected').val(JSON.stringify(response.revisions_affected))
                            } else
                                edit_fd_campaign();
                            },
                        error: function (xhr) {
                            hide_loader();
                            debug(xhr.responseText);
                        }
                    });
                  //  $('#fdOrderedToChange').modal('show');
                }
                else
                    edit_fd_campaign();

            }else{
                $('#weeks_count').focus();
                $('#weeks_count').blur();
                global_notification('error', 'Form invalid!');
            }
        });

        $('#quarter_selector').trigger('change');
    });

  function edit_fd_campaign() {
      $('#fdOrderedToChange').modal('hide');
      if (campaign_obj.interval !== $("input:radio[name=flength]:checked").attr('value')) {
          var fromm = (campaign_obj.interval === 'w') ? 'Weekly' : 'Daily';
          var tooo = ($("input:radio[name=flength]:checked").attr('value') === 'w') ? 'Weekly' : 'Daily';
          if (fromm === 'Weekly' && tooo === 'Daily') {
              $('#fd_change_keep_spots').val('daily');
              swal({
                      title: "Warning",
                      text: "In case you move from Daily to Weekly all the spots will be on the first week day. Do you want to continue?",
                      type: "warning",
                      showCancelButton: false,
                      confirmButtonClass: "btn-danger",
                      confirmButtonText: "OK",
                      cancelButtonText: "Close",
                      closeOnConfirm: true,
                      closeOnCancel: true
                  },
                  function (isConfirm) {
                      if (isConfirm) {
                          $('#app-campaigns-update-dates-form').submit();
                      }
                  });
          } else {
              $('#fd_change_keep_spots').val('daily');
              swal({
                      title: "Warning",
                      text: "Are you sure to change from Daily to Weekly Buy? These changes couldn't be reverted.",
                      type: "warning",
                      showCancelButton: false,
                      confirmButtonClass: "btn-danger",
                      confirmButtonText: "OK",
                      cancelButtonText: "Close",
                      closeOnConfirm: true,
                      closeOnCancel: true
                  },
                  function (isConfirm) {
                      if (isConfirm) {
                          $('#app-campaigns-update-dates-form').submit();
                      }
                  });
          }
      } else {
         // $('#app-campaigns-update-dates-form').submit();
          $('#fdChooseKeepFD').modal('show');
      }
  }

  $('#update_fd_place_spots_selected').on('click', function () {
     var value = $('input:radio[name=place_spots]:checked').val();
      $('#fd_change_keep_spots').val(value);
      $('#app-campaigns-update-dates-form').submit();
      $('#fdChooseKeepFD').modal('hide');

  });

  $("#flight_dates_date_range").on('click', function() {
      if ($('#has_orders').val() !== '1') {
          console.log("true3");
          showCalendar(true, false, $('input[name="calendar_type"]:checked').val());
      } else {
          console.log("false3");
      }
  });

    var flight_dates_date_range;
    var start_date;
    var end_date;

    $("#weeks_count").on("focusin",function(){
        $(this).data('val',$(this).val())
    }).on("change", function(){
        if($('#has_orders').val() !== '1') {
            var v = parseInt($("#weeks_count").val());
            if (v > 0) {
                lchange = 1;
                console.log("new: " + v);
                // var interv = $("#date_range").val();
                // interv = interv.split(" - ");
                var interv = [$('#date_range_1').val(), $('#date_range_2').val()]
                var start = moment(interv[0], "MM/DD/YYYY");
                var end = moment(interv[1], "MM/DD/YYYY");
                var va = $("input:radio[name=flength]:checked").attr('value');
                var cal_ty = $("input:radio[name=calendar_type]:checked").attr('value');
                var unvisible_weeks = $("#hiatus_weeks option").sort(function(a,b){return new Date(b.value) - new Date(a.value);});

                // if(unvisible_weeks.length > 0 && v < parseInt($("#weeks_count").data('val')) && moment(interv[1], "MM/DD/YYYY").isoWeek() == moment(unvisible_weeks[0].value.replace(new RegExp(' ','g'),"")).isoWeek()){
                //     var end = moment(moment(interv[1], "MM/DD/YYYY").subtract(1,'days').day(1).format("MM/DD/YYYY")).subtract(7,'days')
                //     console.log("ENTERING TO THE COMPARISON",end.format("MM/DD/YYYY"))
                // }else
                //     var end = moment(interv[1], "MM/DD/YYYY");
                //
                // if(unvisible_weeks.length > 0 && v < parseInt($("#weeks_count").data('val')) && moment(interv[0], "MM/DD/YYYY").isoWeek() == moment(unvisible_weeks[unvisible_weeks.length - 1].value.replace(new RegExp(' ','g'),"")).isoWeek()){
                //     var start = moment(moment(interv[0], "MM/DD/YYYY").subtract(1,'days').day(1).format("MM/DD/YYYY")).add(7,'days')
                //     console.log("ENTERING TO THE COMPARISON",end.format("MM/DD/YYYY"))
                // }else
                //     var start = moment(interv[0], "MM/DD/YYYY");

                var aux = start.clone();
               // if(cal_ty === 'broadcast') {
                   // console.log('inside broadcast ', (v * 7),' --------- ', aux.startOf('isoWeek').format("MM/DD/YYYY"));
                    if (va === "d")
                        aux.add(v - 1, 'days');
                    else
                        aux.startOf('isoWeek').add((v * 7) - (start.day()), 'days');
              //  }
                // else{
                //     console.log('inside monthly ', (v * 7),' --------- ',aux.format("MM/DD/YYYY"));
                //     if (va === "d")
                //         aux.add(v - 1  , 'days');
                //     else
                //         aux.add((v * 7) -1 , 'days');
                // }
                //
                // var arr_weeks_range = [];
                // let tmp = start.clone().day(1);
                // if( tmp.isAfter(start, 'd') ){
                //     arr_weeks_range.push(tmp.format('MM/DD/YYYY'));
                // }
                // while( tmp.isBefore(end) ){
                //     tmp.add(7, 'days');
                //     arr_weeks_range.push(tmp.format('MM/DD/YYYY'));
                // }
                // if(unvisible_weeks.length > 0)
                //     $.each(unvisible_weeks,function(index,value){
                //         if(arr_weeks_range.indexOf(value.value.replace(new RegExp(' ','g'),"")) !== -1 ){
                //             aux.add(7, 'days')
                //         }
                //     })
                //console.log(start.format("MM/DD/YYYY") + " - " + aux.format("MM/DD/YYYY"));
                //$("#date_range").val(start.format("MM/DD/YYYY") + " - " + aux.format("MM/DD/YYYY"));
                $('#date_range_1').val(start.format("MM/DD/YYYY"))
                $('#date_range_2').val(aux.format("MM/DD/YYYY"))
                $('#date_range_1').data('daterangepicker').setStartDate(start.format("MM/DD/YYYY"))
                $('#date_range_2').data('daterangepicker').setStartDate(aux.format("MM/DD/YYYY"))
                $("#flight_weeks_inputs").html('');
                showCalendar(true,true,$('input[name="calendar_type"]:checked').val());
                lchange = 0;

                //return end.diff(start, 'days');
            } else {
                global_notification('warning', 'Incorrect number of flight weeks ... ');
                $("#weeks_count").val("0");
            }
        }
    });



    // get the last sunday
    function getLastSunday(date) {
        var newDate = new Date(date);
        newDate.setDate(newDate.getDate() - 1);
        while (newDate.getDay() !== 0) {
            newDate.setDate(newDate.getDate() - 1);
        }
        return newDate;
    }

    var currentYear = new Date().getFullYear();
    var currentQuarter = moment().quarter();
    for (var year = currentYear - 1; year <= currentYear + 3; year++) {
        options += '<optgroup label="' + year + '">';
        for (var quarter = 1; quarter <= 4; quarter++) {
            if (quarter === currentQuarter && year === currentYear) {
                options += '<option selected value="' + quarter + 'Q' + year + '">' + quarter + 'Q' + year + '</option>';
            } else
                options += '<option value="' + quarter + 'Q' + year + '">' + quarter + 'Q' + year + '</option>';
        }
        options += '</optgroup>';
    }
    $('#quarter_selector').html(options);

    $('#quarter_selector').select2({
        placeholder: "Select one...",
        'allowClear': true
    // }).on('select2:open', function(){

    }).on('change', function() {
        var quarterSelect = $(this).val(); // quarter selected
        var monthly = document.getElementById('calendar_weeks').checked; //monthly selected
        if (quarterSelect ) {
            console.log(quarterSelect);
            var year = quarterSelect.slice(-4);
            var quarter = quarterSelect.slice(0, 1);

            // calculating start and end date
            var startDate = moment(year + '-' + (quarter * 3 - 2) + '-01', 'YYYY-MM-DD').format('MM/DD/YYYY');
            var endDate = moment(year + '-' + (quarter * 3) + '-' + moment(year + '-' + (quarter * 3) + '-01', 'YYYY-MM-DD').daysInMonth(), 'YYYY-MM-DD').format('MM/DD/YYYY');

            if(!monthly){
                startDate = moment(startDate).startOf('isoWeek').format('MM/DD/YYYY');
                //endDate = moment(endDate).format('MM/DD/YYYY');
                //endDate = new Date(newendDate);
                console.log("END DATE", endDate);
                if (moment(endDate).weekday() !== 0) {
                    endDate = (moment(endDate).startOf('week').format('MM/DD/YYYY'));
                }
                // console.log("NEW END DATE", newendDate);
                // endDate = new Date(newendDate);
                // if (endDate.getDay() !== 0) { // not sunday
                //     endDate = getLastSunday(endDate); // get the last sunday
                // }
            }
            console.log("END DATE", endDate);
            $('#date_range_1').val(startDate);
            $('#date_range_2').val(endDate);
            $('#date_range_1').data('daterangepicker').setStartDate(startDate)
            $('#date_range_2').data('daterangepicker').setStartDate(endDate)
        }
        //$('#date_range_1').val(start.format("MM/DD/YYYY"))
       // $('#date_range_2').val(aux.format("MM/DD/YYYY"))

    });
//radiobutton weekly
    $(".flength_w").on('click', function(){
        console.log("in");
        var v = $("input:radio[name=flength]:checked").attr('value');
        if(v === 'w'){
            console.log("last w: " + last);
            if(last === "" || last === "d") {
                last = v;
                var au = parseInt($("#weeks_count").val());
                console.log((au / 7).toFixed(0));
                $("#weeks_count").val(Math.ceil(au/7));
                //$("#weeks_count").val($("#flight_weeks_inputs input").length);
            }
        }
    });
    //radiobutton daily
    $(".flength_d").on('click', function(){
        console.log("in");
        var v = $("input:radio[name=flength]:checked").attr('value');
        if(v === 'd') {
            console.log("last d: " + last);
            if(last === "" || last === "w") {
                last = v;
                $("#weeks_count").val(calc_diff_days());
            }
        }
    });

    $('input[name="calendar_type"]').on("click",function(){
        showCalendar(true,true,$(this).val())
    })

    function showCalendar(b,flag = false,calendar_type = "weeks"){
        var hiatus_weeks = $("#hiatus_weeks option").map(function(x) { return $("#hiatus_weeks option")[x].value.replace(new RegExp(' ','g'),""); }).toArray();
        $("#hiatus_weeks").html("");
        //temp = $('#date_range').val().split(" - ");
        temp = [$('#date_range_1').val(), $('#date_range_2').val()]

        start_date = moment(temp[0], 'MM/DD/YYYY');
        end_date = moment(temp[1], 'MM/DD/YYYY');

        var months = [];
        temp_start = moment(temp[0], 'MM/DD/YYYY');

        while(true){
            months.push([temp_start.format('M'), temp_start.format('YYYY')]);
            temp_start.add(1, 'month');
            if(temp_start.isAfter(moment(end_date).add(1, 'month').date(1))){
                break;
            }
        }
        if(months.length <= 3) {
            auxm = 200;
        }else{
            if(months.length % 3 === 0){
                auxm = (months.length/3) * 200;
            }else{
                auxm = ((months.length/3).toFixed(0) + 1) * 200;
            }
        }
        cheight = 0;

        var weeks = [];
        temp_start = moment(temp[0], 'MM/DD/YYYY');
        var auxWeekYers = {};
        console.log()
        while(true){
            let weekNumber = temp_start.week();
            if (temp_start.weekday() === 0) {
                weekNumber = temp_start.week() - 1;
            }
            if(typeof auxWeekYers[weekNumber + '' + temp_start.year()] === "undefined") {
                console.log('temp_start_temp_start ', temp_start.format('MM/DD/YYYY'), weekNumber);
                auxWeekYers[weekNumber + '' + temp_start.year()] = [weekNumber, temp_start.year()]
                if(weekNumber != 0)
                weeks.push({
                    week: weekNumber,
                    year: temp_start.year()
                });
            }
            //temp_start.add(1, 'week');
            temp_start.add(1, 'days');
            if(temp_start.isSameOrAfter(moment(end_date).add(1, 'day'))){
                break;
            }
        }
        var v = $("input:radio[name=flength]:checked").attr('value');

        weeks = collect(weeks);
        console.log('weeks_weeks_weeks ', weeks);
        console.log('weeks_weeks_weeks count', $('#weeks_count').val());

        var container = $('#flight_weeks_container');
        container.html('');

        var inputs_container = $('#flight_weeks_inputs');
        var validate_fufllfill = $("#flight_weeks_inputs input").length;
        //inputs_container.html('');

        var month_count = 0;

        if(calendar_type !== "weeks" && months.length > 1 && moment(temp[0], 'MM/DD/YYYY').isoWeek() === moment().seconds(0).minutes(0).hours(0).date(1).month(parseInt(months[1][0]) - 1).year(months[1][1]).isoWeek())
            months.splice(0, 1);

        $.each(months, function(index, value){
            month_count++;

            var html = '';

            if((month_count % 3) === 0){
                html += '<div class="row">';
            }

            var month_start = moment()
                .seconds(0)
                .minutes(0)
                .hours(0)
                .date(1)
                .month(parseInt(value[0]) - 1)
                .year(value[1]);

            html += '<div class="col-md-4 m-b-10" style="min-width: 300px"><div class="flight-date-calendar"><div class="calendar-wrapper"><table><tbody><tr class="heading"><td colspan="2" class="first"></td><td colspan="7"><div class="month">' + month_start.format('MMM YYYY') + '</div></td></tr><tr class="weekday"><td class="first">&nbsp;</td><td>#</td><td>M</td><td>T</td><td>W</td><td>R</td><td>F</td><td>S</td><td>U</td></tr>';

            calendar_start = moment(month_start).startOf('isoWeek');
            calendar_end = moment(month_start).add(1, 'month').startOf('isoWeek');

            if((calendar_end.date() !== 1 && calendar_type === "weeks") || (calendar_end.date() !== 1 && month_count === months.length)){
                calendar_end.add(1, 'week');
            }

            while(calendar_end.isAfter(calendar_start)){
                if (calendar_start.day() === 1) {
                    let auxYear = moment(calendar_start).year()
                    let auxYear2 = moment(calendar_start).add(5, 'days').year()
                    let auxWeek = moment(calendar_start).week()
                    if(auxYear < auxYear2 && auxYear2 === end_date.year())
                        auxYear = auxYear2;
                    var end_fill = moment($('#date_range_2').val()).format('YYYY-MM-DD')
                    if(typeof weeks.where('year', auxYear).where('week', auxWeek).first() === 'undefined' || calendar_start.format('YYYY-MM-DD') > end_fill){
                        html += '</tr><tr class="days"><td class="day select out-of-range"></td><td></td>';
                    }else{
                        var sel = (!b || (flag && hiatus_weeks.length > 0 && hiatus_weeks.indexOf(calendar_start.format('MM/DD/YYYY')) !== -1)) ? 'unselected' : 'selected';
                        html += '</tr><tr class="days '+ sel +'"><td class="day select in-range" data-date="' + calendar_start.format('YYYY-MM-DD') + '"><i class="fa fa-check fa-fw"></i></td><td class="day weeknum"> ' + calendar_start.week() + '</td>';

                        if(inputs_container.find('input[name="campaign_weeks[]"][value="' + calendar_start.format('YYYY-MM-DD') + '"]').length === 0){
                            console.log("hiden: " + calendar_start.format('YYYY-MM-DD'));
                            if(validate_fufllfill === 0 && (!flag || hiatus_weeks.length == 0 || hiatus_weeks.indexOf(calendar_start.format('MM/DD/YYYY')) === -1))
                                inputs_container.append('<input type="hidden" name="campaign_weeks[]" value="' + calendar_start.format('YYYY-MM-DD') + '" value="true" />');
                        }
                    }
                }

                classes = 'day ';

                if((parseInt(calendar_start.format('YYYYMMDD')) < parseInt(start_date.format('YYYYMMDD')))
                    || (parseInt(calendar_start.format('YYYYMMDD')) > parseInt(end_date.format('YYYYMMDD')))){
                    classes += 'out-of-range ';
                }

                if(value[0] !== calendar_start.format('M') && calendar_type === "weeks"){
                    classes += 'out-of-month ';
                }
                console.log("calendar_end calendar_start.format     ", classes,calendar_start.format('YYYY-MM-DD'))

                html += '<td class="' + classes + '">' + calendar_start.format('DD') + '</td>';

                calendar_start.add(1, 'day');
            }
            html += '</tr>';

            html += '</tbody></table></div></div></div>';

            if(((month_count % 3) === 2) || (month_count === months.length)){
                html += '</div>';
            }

            container.append(html);

            var auu = [];
            var hhtml = "";
            $.each($('td.day.select'), function(){
                var auxx = $(this).attr('data-date');
                if(/*upd_weeks.indexOf(auxx) === -1*/ $('#flight_weeks_inputs input[value="' + auxx + '"]').length === 0 && typeof auxx !== 'undefined') {
                    var au = $(this).attr('data-date').split("-");
                    au = au[1] + " / " + au[2] + " / " + au[0];
                    if (auu.indexOf(au) === -1) {
                        auu.push(au);
                        hhtml += '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>';
                    }
                }
            });
            $("#hiatus_weeks").html(hhtml);
            sort_hiatus();

            if(!b){
                var upd_weeks = $("#update_weeks").val();
                if(upd_weeks !== ""){
                    console.log("upd weeks");
                    console.log(upd_weeks);
                    var html = '';
                    var arr = upd_weeks.split('|');
                    var ins_aux = [];
                    // for(var i=0;i<arr.length-1;i++){
                    //     var aux1 = arr[i].split(' ');
                    //     console.log("divide");
                    //     console.log(aux1);
                    //     //var aux = aux1[4].split('-');
                    //     html += '<input type="hidden" name="campaign_weeks[]" value="'+ aux1[0].trim() +'">';
                    //     $.each($('td.day.select[data-date="' + aux1[0].trim() + '"]'), function(){
                    //         //$(this).closest('.days').removeClass('unselected').addClass('selected');
                    //     });
                    // }

                    $("#flight_weeks_inputs input").each(function (index,value) {
                        html += '<input type="hidden" name="campaign_weeks[]" value="'+ $(value).val().trim() +'">';
                        $.each($('td.day.select[data-date="' + $(value).val().trim() + '"]'), function(){
                            $(this).closest('.days').removeClass('unselected').addClass('selected');
                        });
                    })

                    // var auu = [];
                    // var hhtml = "";
                    // $.each($('td.day.select'), function(){
                    //     var auxx = $(this).attr('data-date');
                    //     if(/*upd_weeks.indexOf(auxx) === -1*/ $('#flight_weeks_inputs input[value="' + auxx + '"]').length === 0 && typeof auxx !== 'undefined') {
                    //         var au = $(this).attr('data-date').split("-");
                    //         au = au[1] + " / " + au[2] + " / " + au[0];
                    //         if (auu.indexOf(au) === -1) {
                    //             auu.push(au);
                    //             hhtml += '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>';
                    //         }
                    //     }
                    // });
                    // $("#hiatus_weeks").html(hhtml);
                    // sort_hiatus();
                    inputs_container.html('');
                    inputs_container.html(html);
                }
            }

        });

        if(lchange === 0) {
            console.log("EDIT");
            if (v === "w") {
                last = v;
                //$("#weeks_count").val($("#flight_weeks_inputs input").length);
                console.log("WEEKS DIFFERENCE: ",calc_diff_weeks())
                $("#weeks_count").val(calc_diff_weeks());
            } else {
                last = v;
                $("#weeks_count").val(calc_diff_days());
            }
        }

        $("#removeall").on('click', function(){
            $('#hiatus_weeks option').each(function(){
                var daux = $(this).val().split(' / ');
                daux = daux[2] + "-" + daux[0] + "-" + daux[1];
                var lastd = "";
                container.find('td.day.select').each(function(){
                    var date = $(this).attr('data-date');
                    if(daux === date) {
                        console.log(date + "  " + lastd);
                        if(date !== lastd) {
                            $(this).click();
                            lastd = date;
                        }
                    }else
                        console.log(date + " " + daux);
                });
                $(this).remove();
            });
        });

        $("#removesel").on('click', function(){
            $('#hiatus_weeks option:selected').each(function(){
                var daux = $(this).val().split(" / ");
                daux = daux[2] + "-" + daux[0] + "-" + daux[1];
                var lastw = "";
                container.find('td.day.select').each(function(){
                    var date = $(this).attr('data-date');
                    if(daux === date) {
                        if(date !== lastw) {
                            $(this).click();
                            lastw = date;
                        }
                    }else
                        console.log(date + " " + daux);
                });
                $(this).remove();
            });
            sort_hiatus();
        });

        if($('#has_orders').val() !== '1') {
            container.find('td.day.select').bind('click', function () {
                date = $(this).attr('data-date');
                var au = date.split("-");
                au = au[1] + " / " + au[2] + " / " + au[0];

                if ($(this).closest('.days').hasClass('selected')) {
                    $.each($('td.day.select[data-date="' + date + '"]'), function () {
                        $(this).closest('.days').addClass('unselected').removeClass('selected');
                    });
                    $('input[name="campaign_weeks[]"][value="' + date + '"]').remove();
                    console.log("au2: " + au);
                    $("#hiatus_weeks").html($("#hiatus_weeks").html() + '<option class="align-middle" style="height: 30px;border-bottom: 0.5px solid silver;padding-left: 20px; padding-top:5px" value="' + au + '">' + au + '</option>');
                    var v = $("input:radio[name=flength]:checked").attr('value');
                    if (v === 'd')
                        $("#weeks_count").val(calc_diff_days());
                    else
                        $("#weeks_count").val(parseInt($("#weeks_count").val()) - 1);
                    sort_hiatus();
                } else {
                    $.each($('td.day.select[data-date="' + date + '"]'), function () {
                        $(this).closest('.days').removeClass('unselected').addClass('selected');
                    });
                    $('#flight_weeks_inputs').append('<input type="hidden" name="campaign_weeks[]" value="' + date + '" value="true" />');

                    $('#hiatus_weeks option').each(function () {
                        if ($(this).val() === au) {
                            $(this).remove();
                            return;
                        }
                    });
                    var v = $("input:radio[name=flength]:checked").attr('value');
                    if (v === 'd')
                        $("#weeks_count").val(calc_diff_days());
                    else
                        $("#weeks_count").val(parseInt($("#weeks_count").val()) + 1);
                    sort_hiatus();
                }
            });
        }
        first = 0;
    }
}
